/* To_Be_Deleted - remove the constants once completely switched to new nav */
export const WELCOME_MESSAGE = "Welcome to Campaigns! Manage placements & media for your linked advertiser accounts.";
export const APP_NAME = "Campaigns";
export const APP_TITLE = "Planning & Performance";
export const INDEX_PAGE_HOVER = "Campaigns Home page";
export const INDEX_MENU_LABEL = "Home";
export const LOGOUT_LABEL = "Log Out";
export const CREATE_RECORD = "Create Record";
export const ADD_PLACEMENT = "Add Placement";
export const INDEX_PAGE = "Home";
export const CREATE_RECORD_TITLE = "Add Placement";
export const EDIT_RECORD_TITLE = "Edit Placement";
export const DUPLICATE_RECORD_TITLE = "Create Copy of Placement : ";
export const REMOVE_RECORD_TITLE = 'Remove Placement';
export const CANCEL = "CANCEL";
export const SAVE_RECORD = "SAVE RECORD";
export const SAVE = "Save";
export const EMPTY = "";
export const COMMA = " , ";
export const HYPHEN = ' - ';
export const SLASH = ' / ';
export const COLON = ': ';
export const LEFT_ROUND_BRACKET = ' (';
export const RIGHT_ROUND_BRACKET = ') ';
export const PIPE = ' | ';
export const PUBLISHER_NAME_NOT_AVAILABLE = 'Publisher Name Unavailable';
export const PUBLISHER_PROPERTY_FETCHING_MESSAGE = "Fetching Property Details...";
export const PUBLISHER_PROPERTY_ERROR_MESSAGE = "Sorry, we are facing an issue. Please try again!";
export const YOY_OBSERVED_LOADING_MESSAGE = 'Calculating YoY% Observed...'
export const YOY_OBSERVED_ERROR_MESSAGE = 'Sorry, we are unable to help you with YoY Observed(%).'
export const HTML_HIDDEN_TAG = <p hidden></p>;
export const PUBLISHER_PROPERTY_NOT_AVAILABLE = "Not Available";
export const NOT_AVAILABLE = "N/A";
export const DISPLAY_NOT_AVAILABLE = "Not Available";
export const PUBLISHER_PROPERTY_INVALID_PID = "Invalid PID";
export const DETAILS_TAB_LABEL = "Details"
export const Performance_TAB_LABEL = "Cost & Proj. Lift"
export const Booking_TAB_LABEL = "Booking"
export const Validation_TAB_LABEL = "Validation"
export const Payment_TAB_LABEL = "Payment"
export const VALIDATION_DETAILS_ERROR_MESSAGE = "Validation details can be provided only if status is 'Booked'";
export const BOOKING_DETAILS_ERROR_MESSAGE = "Booking details can be provided only if status is 'Booked'";
export const BOOKING_DETAILS_TAB_ERROR_MESSAGE = "Mandatory fields in Booking tab to be filled out"
export const PERFORMANCE_DETAILS_TAB_ERROR_MESSAGE = "Mandatory fields in " + Performance_TAB_LABEL + " tab to be filled out"
export const IO_FIELD_HELP_MESSAGE = "If IO# is unavailable, please enter 'N/A'."
export const PAYMENT_DETAILS_ERROR_MESSAGE = "Payment details can be provided only if status is 'Booked'";
export const CAMPAIGN_DATAGRID_TITLE = "Placements";
export const CAMPAIGN_DATAGRID_CAPTION = "Showing max. 1000 placements of your linked advertisers, default sorted by start date. Use download option for all placements.";
export const START_DATE_AND_END_DATE_ERROR_MESSAGE = "Start Date & Time is greater than the End Date & Time"

export const ENTER_NUMBER_PLACEHOLDER = "Enter Number"
export const DROPDOWN_PLACEHOLDER = 'Select...';
export const Filter_Header = "Filters";
export const NON_NULL_OPTION_VALUES = {value: "", label: "Select"}

export const DETAILS_TIMESTAMP_START_DATE = "00:00:00"
export const DETAILS_TIMESTAMP_END_DATE = "23:59:59"
export const DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const MMM_DD_YYYY_HH_MI_AM_PM = 'MMM DD, YYYY hh:mm A';
export const YYYY_MM_DD = 'YYYY-MM-DD';
export const MMM_DD_YYYY = 'MMM DD, YYYY';

export const AUTO_CAL_REVENUE = 'Auto Calculated from the same Month of Last Year :';
export const MANUAL_CAL_REVENUE = 'Manually Calculated :';

export const PLACEMENT_TYPE = [
    {value: 'App Push', label: 'App Push'},
    {value: 'Article Inclusion', label: 'Article Inclusion'},
    {value: 'Cashback Event', label: 'Cashback Event'},
    {value: 'Category Leader', label: 'Category Leader'},
    {value: 'Category Page', label: 'Category Page'},
    {value: 'Content', label: 'Content'},
    {value: 'Content - Dedicated Review', label: 'Content - Dedicated Review'},
    {value: 'Content - Editorial', label: 'Content - Editorial'},
    {value: 'Content - Gift Guide', label: 'Content - Gift Guide'},
    {value: 'Content - Multi Merchant Review', label: 'Content - Multi Merchant Review'},
    {value: 'Coupon Page', label: 'Coupon Page'},
    {value: 'Deal Page', label: 'Deal Page'},
    {value: 'Double Cashback', label: 'Double Cashback'},
    {value: 'Footer Ads', label: 'Footer Ads'},
    {value: 'Homepage', label: 'Homepage'},
    {value: 'Homepage - Search Keywords', label: 'Homepage - Search Keywords'},
    {value: 'Homepage Carousel', label: 'Homepage Carousel'},
    {value: 'Loyalty', label: 'Loyalty'},
    {value: 'Make Good', label: 'Make Good'},
    {value: 'Mobile App', label: 'Mobile App'},
    {value: 'Mobile Messaging', label: 'Mobile Messaging'},
    {value: 'Mobile Webpage', label: 'Mobile Webpage'},
    {value: 'Multi-Merchant Email', label: 'Multi-Merchant Email'},
    {value: 'Package', label: 'Package'},
    {value: 'Pop-Up Ads', label: 'Pop-Up Ads'},
    {value: 'Search', label: 'Search'},
    {value: 'Seasonal Event Page', label: 'Seasonal Event Page'},
    {value: 'Social Media - Facebook', label: 'Social Media - Facebook'},
    {value: 'Social Media - Google+', label: 'Social Media - Google+'},
    {value: 'Social Media - Instagram', label: 'Social Media - Instagram'},
    {value: 'Social Media - Snapchat', label: 'Social Media - Snapchat'},
    {value: 'Social Media - TikTok', label: 'Social Media - TikTok'},
    {value: 'Social Media - Twitter', label: 'Social Media - Twitter'},
    {value: 'Social Media - WeChat', label: 'Social Media - WeChat'},
    {value: 'Social Media - Weibo', label: 'Social Media - Weibo'},
    {value: 'Social Media - YouTube', label: 'Social Media - YouTube'},
    {value: 'Social Media - Others', label: 'Social Media - Others'},
    {value: 'Solo Email', label: 'Solo Email'},
    {value: 'Sponsored', label: 'Sponsored'},
    {value: 'Staff Picks', label: 'Staff Picks'},
    {value: 'Store Page Category', label: 'Store Page Category'},
    {value: 'Widget', label: 'Widget'},
    {value: 'Other', label: 'Other'}
];
export const DYNAMIC_OR_STATIC_FIELD = [
    {value: 'Dynamic', label: 'Dynamic'},
    {value: 'Static', label: 'Static'},
];

export const NEW_OR_COMPED_FIELD = [
    {value: 'Comped', label: 'Comped'},
    {value: 'New', label: 'New'}
];

export const YES_NO_OPTION = [
    {value: 'Yes', label: 'Yes'},
    {value: 'No', label: 'No'},
];

const NA_OPTION = {value: 'N/A', label: 'N/A'};

const NA_FLAT_FEE_OPTION = {value: 'N/A- Flat Fee Only', label: 'N/A- Flat Fee Only'};

export const PAID_IN_CJ_OPTION = [
    {value: 'Fully Paid', label: 'Fully Paid'},
    {value: 'Partially Paid', label: 'Partially Paid'},
    {value: 'Not Paid', label: 'Not Paid'},
    {value: 'CPA Increase Only', label: 'CPA Increase Only'},
    {value: 'Make Good - No Cost', label: 'Make Good - No Cost'},
    NA_OPTION,
];

export const YES_NO_NA_OPTION = [
    ...YES_NO_OPTION,
    NA_OPTION,
];

export const FLAT_FEE_OPTION = [
    ...YES_NO_OPTION,
    NA_FLAT_FEE_OPTION
];

export const BOOKED = "Booked";
export const PROPOSED = "Proposed";
export const DECLINED = "Declined";
export const STATUS = "status";
export const STATUS_LABEL = "Status";

export const PLACEMENT_STATUS_FIELD = [
    {value: BOOKED, label: BOOKED},
    {value: PROPOSED, label: PROPOSED},
    {value: DECLINED, label: DECLINED}
];
export const DETAILS_TAB_ERROR_MESSAGE = "Mandatory fields in Details tab to be filled out"
export const EVENTS = [
    {value: '', label: 'Select'},
    {value: 'August Bank Holiday', label: 'August Bank Holiday'},
    {value: 'Back to School', label: 'Back to School'},
    {value: 'Black Friday', label: 'Black Friday'},
    {value: 'Blue Monday (January)', label: 'Blue Monday (January)'},
    {value: 'Boxing Day', label: 'Boxing Day'},
    {value: 'Cheltenham Festival', label: 'Cheltenham Festival'},
    {value: 'Christmas', label: 'Christmas'},
    {value: 'Cyber Monday', label: 'Cyber Monday'},
    {value: 'Cyber/Giving Tuesday', label: 'Cyber/Giving Tuesday'},
    {value: 'Early May Bank Holiday', label: 'Early May Bank Holiday'},
    {value: 'Easter', label: 'Easter'},
    {value: 'FA Cup', label: 'FA Cup'},
    {value: 'Father\'s Day', label: 'Father\'s Day'},
    {value: 'Grand National', label: 'Grand National'},
    {value: 'Halloween', label: 'Halloween'},
    {value: 'Holiday', label: 'Holiday'},
    {value: 'Independence Day', label: 'Independence Day'},
    {value: 'Labor Day', label: 'Labor Day'},
    {value: 'Late May Bank Holiday', label: 'Late May Bank Holiday'},
    {value: 'Lunar New Year', label: 'Lunar New Year'},
    {value: 'Memorial Day', label: 'Memorial Day'},
    {value: 'Mother\'s Day', label: 'Mother\'s Day'},
    {value: 'New Year', label: 'New Year'},
    {value: 'President\'s Day', label: 'President\'s Day'},
    {value: 'Product Launch', label: 'Product Launch'},
    {value: 'Single\'s Day', label: 'Single\'s Day'},
    {value: 'St Patrick\'s Day', label: 'St Patrick\'s Day'},
    {value: 'Super Bowl', label: 'Super Bowl'},
    {value: 'Tax Season', label: 'Tax Season'},
    {value: 'Thanksgiving', label: 'Thanksgiving'},
    {value: 'Valentine\'s Day', label: 'Valentine\'s Day'},
    {value: 'Wimbledon', label: 'Wimbledon'},
    {value: 'World Cup', label: 'World Cup'}
];
export const OFFER_TYPE_FIELD = [
    {value: "AMOUNT_OFF", label: "AMOUNT_OFF"},
    {value: "BNPL (Buy Now Pay Later)", label: "BNPL (Buy Now Pay Later)"},
    {value: "BOGO", label: "BOGO"},
    {value: "COUPON", label: "COUPON"},
    {value: "EVERGREEN", label: "EVERGREEN"},
    {value: "FREE_GIFT", label: "FREE_GIFT"},
    {value: "FREE_SHIP", label: "FREE_SHIP"},
    {value: "INTRODUCTORY_OFFER", label: "INTRODUCTORY_OFFER"},
    {value: "PERCENT_OFF", label: "PERCENT_OFF"},
    {value: "PRODUCT", label: "PRODUCT"},
    {value: "PUBLISHER EXCLUSIVE", label: "PUBLISHER EXCLUSIVE"},
    {value: "SUBSCRIPTION", label: "SUBSCRIPTION"},
];

export const OFFER_CONDITION_FIELD = [
    {value: "BRAND_CARD_SIGNUP_SPECIFIC", label: "BRAND_CARD_SIGNUP_SPECIFIC"},
    {value: "BRAND_CARD_SPECIFIC", label: "BRAND_CARD_SPECIFIC"},
    {value: "COMBO CODE", label: "COMBO CODE"},
    {value: "DEMOGRAPHICS", label: "DEMOGRAPHICS"},
    {value: "EMAIL_SIGNUP_REQUIRED", label: "EMAIL_SIGNUP_REQUIRED"},
    {value: "LOCATION_SPECIFIC", label: "LOCATION_SPECIFIC"},
    {value: "LOYALTY_REQUIRED", label: "LOYALTY_REQUIRED"},
    {value: "MEMBERSHIP_REQUIRED", label: "MEMBERSHIP_REQUIRED"},
    {value: "MULTI_BUY", label: "MULTI_BUY"},
    {value: "NEW_CUSTOMER_SPECIFIC", label: "NEW_CUSTOMER_SPECIFIC"},
    {value: "POINT_OF_SALE_SPECIFIC", label: "POINT_OF_SALE_SPECIFIC"},
    {value: "PRODUCT_SPECIFIC", label: "PRODUCT_SPECIFIC"},
    {value: "PROMO_CODE", label: "PROMO_CODE"},
    {value: "VANITY", label: "VANITY"},
    {value: "N/A", label: "N/A"},
];

export const CREATE_MODAL_SUCCESS_MESSAGE_TO_COMPARE = "successfully!"
export const CREATE_MODAL_ERROR_MESSAGE_TO_COMPARE = "Please try again or contact the Support Team."
export const CREATE_MODAL_REMOVED_PLACEMENT_ERROR_MESSAGE_TO_COMPARE = "This placement has already been removed & cannot be edited";
export const ADVERTISER_LABEL = "Advertiser"
export const MAX_LENGTH_500 = "500";
export const MAX_LENGTH_200 = "200";
export const PAYMENT_NOTES_TEXT_FIELD_MAX_CHARACTER = "4000"
export const EDIT_PLACEMENT = "Edit"
export const DUPLICATE_PLACEMENT = "Duplicate"
export const REMOVE_PLACEMENT = "Remove"
export const COPY_OF = "Copy of"
export const SPACE = ' ';
export const YES = 'Yes';
export const NO = 'No';

/*DataTable Column Headers and Create Modal Labels*/
export const PLACEMENT_ID_LABEL = "Placement ID";
export const ADVERTISER_CID_LABEL = "Advertiser CID";
export const ADVERTISER_NAME_LABEL = "Advertiser Name";
export const PLACEMENT_STATUS_LABEL = "Placement Status";
export const CALENDAR_YEAR_LABEL = "Calendar Year";
export const CALENDAR_QTR_LABEL = "Calendar Quarter";
export const CALENDAR_MONTH_LABEL = "Calendar Month";
export const CALENDAR_WEEK_LABEL = "Calendar Week";
export const PLACEMENT_START_DATE_LABEL = "Start Date & Time";
export const PLACEMENT_END_DATE_LABEL = "End Date & Time";
export const PUBLISHER_NAME_LABEL = "Publisher Name";
export const PUBLISHER_CID_LABEL = "Publisher CID";
export const PUBLISHER_PROPERTY_TEXT_FIELD = "Publisher Property ID";
export const PLACEMENT_TYPE_LABEL = "Placement Type [Location]";
export const PLACEMENT_NAME = "Placement Name";
export const ORIGINAL_PUBLISHER_COMMISSION_LABEL = "Original Publisher Commission (%)";
export const NEW_PUBLISHER_COMMISSION_LABEL = "New Publisher Commission (%)";
export const ORIGINAL_FLAT_FEE_LABEL = "Original/Rate Card Flat Fee Cost";
export const CJ_FLAT_FEE_LABEL = "Negotiated Flat Fee Cost";
export const WEBSITE_URL_LABEL = "Website URL";
export const PROPERTY_TYPE_LABEL = "Property Type";
export const PROPERTY_MODEL_LABEL = "Property Model";
export const PERSONALIZED_TARGETED_LABEL = "Personalized/Targeted Offer";
export const DYNAMIC_STATIC_LABEL = "Dynamic vs. Static Placement Type";
export const RANK_OR_SPOT_NUMBER_OF_PLACEMENT_TEXT_FIELD = "Placement Spot/Position";
export const EVENTS_LABEL = "Events";
export const SEND_SIZE_LABEL = "Send Size, Expected Unique Views";
export const PACKAGE_NAME_LABEL = "Package Name";
export const NEW_OR_COMPED_LABEL = "Comped (Compared to) Last Year or New";
export const VIP_CONTENT_LABEL = "VIP Content Campaign";
export const PROPOSED_OFFER_USED_DESCRIPTION_TEXT_FIELD = "Proposed Ad Copy";
export const SOV_BEFORE_LABEL = "Share Of Voice Pre-Placement (%)";
export const ACTUAL_SOV_AFTER_LABEL = "Share of Voice Post-Placement (%)";
export const BASELINE_SELECTION_LABEL = "Average Daily Revenue Baseline";
export const YOY_GROWTH_TREND_LABEL = "Organic Lift Over Baseline (%)";
export const PRIOR_PLACEMENT_LIFT_LABEL = "Expected Placement Lift Over Baseline (%)";
export const OTHER_EXPECTED_LIFT_LABEL = "Other Lift Over Baseline e.g. Sale (%)";
export const TIERED_OFFER_LABEL = "Tiered Offer Details";
export const OFFER_TYPE_LABEL = "Offer Type";
export const OFFER_VALUE_LABEL = "Offer Value";
export const OFFER_CONDITIONS_LABEL = "Offer Conditions";
export const OFFER_THRESHOLD_LABEL = "Offer Threshold";
export const LINK_ID_LABEL = "Link ID";
export const ASSETS_NEEDED_LABEL = "Assets Needed";
export const ASSET_DUE_DATE_LABEL = "Asset Due Date";
export const ASSETS_SENT_BY_ADVERTISER_LABEL = "Assets Sent By Advertiser";
export const CJ_MARKETPLACE_IO_LABEL = "CJ Marketplace IO#";
export const PUBLISHER_IO_LABEL = "Publisher IO#";
export const IO_SIGNED_LABEL = "IO Signed?";
export const PROGRAM_TERM_NAME_LABEL = "Program Term Name";
export const PROGRAM_TERM_PUSHED_LABEL = "Has Program Term Been Pushed?";
export const CASHBACK_AMOUNT_ONSITE_LABEL = "Cashback/Incentive Amount";
export const PUBLISHER_USED_LINK_ID_LABEL = "Publisher Used Specified Link ID";
export const OFFER_DESCRIPTION_TEXT_LABEL = "Live Ad Copy on Publisher Property";
export const CORRECT_OFFER_USED_LABEL = "Was Correct Offer Used in Placement";
export const PATH_TO_SAVED_EMAIL_LABEL = "Path for Screenshot/Email";
export const VALIDATION_NOTES_LABEL = "Validation Notes";
export const PAID_IN_CJ_LABEL = "Paid in CJ?";
export const PAYMENT_DATE_LABEL = "Payment Date";
export const PAYMENT_OID_LABEL = "Payment OID / Transaction ID";
export const AMOUNT_PAID_LABEL = "Amount Paid";
export const PAYMENT_NOTES_LABEL = "Payment Notes";
export const PROJECTED_SPEND_WITH_PLACEMENT_LABEL = "Projected Spend with Placement";
export const PROJECTED_SPEND_WITHOUT_PLACEMENT_LABEL = "Projected Spend without Placement";
export const PROJECTED_REVENUE_WITH_PLACEMENT_LABEL = "Projected Revenue with Placement";
export const PROJECTED_REVENUE_WITHOUT_PLACEMENT_LABEL = "Projected Revenue without Placement";
export const PROJECTED_ROAS_LABEL = "Projected ROAS";
export const PROJECTED_INCREMENTAL_REVENUE_LABEL = "Projected Incremental Revenue";
export const PROJECTED_INCREMENTAL_SPEND_LABEL = "Projected Incremental Spend";
export const PROJECTED_INCREMENTAL_ROAS_LABEL = "Projected Incremental ROAS";
export const LAST_YEAR_ACTUAL_REVENUE_LABEL = "Last Year Rev. for Same Placement Dates";
export const LAST_YEAR_ACTUAL_COMMISSION_LABEL = "Last Year Comm. for Same Placement Dates";
export const YOY_QUARTER_START_DATE_CURRENT_YEAR_LABEL = "Past 3 mos - Current Year(Start Date)";
export const YOY_QUARTER_END_DATE_CURRENT_YEAR_LABEL = "Past 3 mos - Current Year(End Date)";
export const YOY_QUARTER_START_DATE_LAST_YEAR_LABEL = "Past 3 mos - Last Year(Start Date)";
export const YOY_QUARTER_END_DATE_LAST_YEAR_LABEL = "Past 3 mos - Last Year(End Date)";
export const YOY_CALCULATION_CURRENT_YEAR_REVENUE_LABEL = "Past 3 mos - Current Year Revenue";
export const YOY_CALCULATION_LAST_YEAR_REVENUE_LABEL = "Past 3 mos - Last Year Revenue";
export const YOY_OBSERVED_PERCENTAGE_LABEL = "Past 3 mos - YoY Observed (%)";
export const AVERAGE_DAILY_REVENUE_BASELINE_LABEL = "Average Daily Revenue Baseline";
export const CALCULATED_BASELINE_USED_LABEL = "Auto Calculated Baseline Used";
export const ACTUAL_REVENUE_LABEL = "Actual Revenue";
export const ACTUAL_INCREMENTAL_REVENUE_LABEL = "Actual Incremental Revenue";
export const ACTUAL_TOTAL_COMMISSIONS_LABEL = "Actual Total Commissions";
export const ACTUAL_TOTAL_SPEND_LABEL = "Actual Total Spend";
export const ACTUAL_INCREMENTAL_SPEND_LABEL = "Actual Incremental Spend";
export const ACTUAL_ROAS_LABEL = "Actual ROAS";
export const ACTUAL_INCREMENTAL_ROAS_LABEL = "Actual Incremental ROAS";
export const ACTUAL_CLICKS_LABEL = "Actual Clicks";
export const ACTUAL_RPV_LABEL = "Actual RPV";
export const ACTUAL_SALES_LABEL = "Actual Action Count";
export const ACTUAL_CR_LABEL = "Actual CR (%)";
export const ACTUAL_PLACEMENT_LIFT_LABEL = "Actual Placement Lift (%)";
export const REVENUE_DELTA_LABEL = "Revenue Delta $ (Projected vs. Actuals)";
export const REVENUE_ACCURACY_LABEL = "Revenue Accuracy % (Projected vs. Actuals)";
export const ROAS_ACCURACY_LABEL = "ROAS Accuracy % (Projected vs. Actuals)";
export const PROGRAM_TERM_DESCRIPTION_LABEL = "Program Term Description";

/* Excel Addition Column Header Labels*/
export const START_DATE_LABEL = "Start Date";
export const END_DATE_LABEL = "End Date";
export const ADVERTISER_TIMEZONE_LABEL = "Advertiser Timezone";
export const ADVERTISERS_FUNCTIONAL_CURRENCY_LABEL = "Advertiser's Functional Currency";
export const FISCAL_YEAR_LABEL = "Fiscal Year";
export const FISCAL_QUARTER_LABEL = "Fiscal Quarter";
export const FISCAL_MONTH_LABEL = "Fiscal Month";
export const FISCAL_WEEK_LABEL = "Fiscal Week";
export const PLACEMENT_CREATION_DATE_TIME_LABEL = "Placement Creation Date & Time";
export const PLACEMENT_CREATED_BY_LABEL = "Placement Created By";
export const START_TIME_LABEL = "Start Time";
export const END_TIME_LABEL = "End Time";
export const PERFORMANCE_LAST_UPDATED_ON_LABEL = "Performance Last Updated On";
export const CJ_INVOICE_MONTH_LABEL = "CJ Invoice Month";
export const VALIDATION_DETAILS_CREATED_ON_LABEL = "Validation Details Created On";
export const VALIDATION_DETAILS_CREATED_BY_LABEL = "Validation Details Created By";
export const VALIDATION_DETAILS_LAST_UPDATED_ON_LABEL = "Validation Details Last Updated On";
export const VALIDATION_DETAILS_LAST_UPDATED_BY_LABEL = "Validation Details Last Updated By";
export const PAYMENT_DETAILS_CREATED_ON_LABEL = "Payment Details Created On";
export const PAYMENT_DETAILS_CREATED_BY_LABEL = "Payment Details Created By";
export const PAYMENT_DETAILS_LAST_UPDATED_ON_LABEL = "Payment Details Last Updated On";
export const PAYMENT_DETAILS_LAST_UPDATED_BY_LABEL = "Payment Details Last Updated By";

/*Modal Tooltip Definitions*/
export const PLACEMENT_STATUS_TOOLTIP = 'Booked, Proposed, etc.';

export const ADVERTISER_TOOLTIP = 'Advertiser Name & Advertiser/Client Company ID';
export const NEW_OR_COMPED_TOOLTIP = 'Indicate whether this same placement was run last year, or if it\'s new to the Advertiser';
export const DYNAMIC_STATIC_TOOLTIP = 'Dynamic: Media placement within a rotation on pub site. Static: Media placement does not rotate among other placements on the site.';
export const END_DATE_TIME_TOOLTIP = 'Placement end date & time (in Advertiser\'s Preferred Reporting Timezone)';
export const EVENTS_TOOLTIP = 'Placement is booked/proposed for a specific event e.g., on Father\'s Day';
export const FISCAL_MONTH_TOOLTIP = 'Fiscal month in which the placement ran or is scheduled to run';
export const FISCAL_QUARTER_TOOLTIP = 'Fiscal quarter in which the placement ran or is scheduled to run';
export const FISCAL_WEEK_TOOLTIP = 'Fiscal week in which the placement ran or is scheduled to run';
export const FISCAL_YEAR_TOOLTIP = 'Fiscal year in which the placement ran or is scheduled to run';
export const PUBLISHER_PID_TOOLTIP = 'Publisher Property ID';
export const START_DATE_TIME_TOOLTIP = 'Placement start date & time (in Advertiser\'s Preferred Reporting Timezone)';
export const PLACEMENT_TYPE_TOOLTIP = 'e.g., Homepage, Email, Event';
export const PLACEMENT_TARGETED_TOOLTIP = 'Will the placement only be sent to/shown to a specific group of customers/shoppers?';
export const VIP_CONTENT_TOOLTIP = 'Use if the placement is a VIP Content Campaign';
export const PACKAGE_NAME_TOOLTIP = 'Can be used to categorize the placement as part of a package, OR for any other categorization needed by the Adv (e.g. new product launch, client event, etc.)';
export const PLACEMENT_SPOT_TOOLTIP = 'The booked/proposed spot or position of the placement on the website/newsletter/email';
export const PROPOSED_AD_COPY_TOOLTIP = 'Offer description';
export const PLACEMENT_NAME_TOOLTIP = 'Name of the placement';

export const ORIGINAL_PUBLISHER_COMMISSION_TOOLTIP = 'Commission rate live before the placement starts OR publisher\'s default commission rate with this Advertiser';
export const NEW_PUBLISHER_COMMISSION_TOOLTIP = 'New commission rate negotiated for the placement run dates';
export const ORIGINAL_FLAT_FEE_TOOLTIP = 'Original/un-negotiated Flat Fee Rate offered by publisher or Rate Card Rate';
export const CJ_FLAT_FEE_TOOLTIP = 'Flat fee price of the placement negotiated by CJ (if lower than the Original/Rate Card Flat Fee Cost)';
export const YOY_GROWTH_TREND_TOOLTIP = 'Organic lift input by user to be used in projected KPI calculations';
export const PRIOR_PLACEMENT_LIFT_TOOLTIP = 'The actual performance lift % observed from prior placement performance. This is required to run projections for the proposed placement.';
export const OTHER_EXPECTED_LIFT_TOOLTIP = 'Use this field to isolate lift due to seasonality or other factors. This value will be incorporated into the projected KPI calculations';
export const SEND_SIZE_TOOLTIP = 'Send Size: Audience size for a newsletter, Expected Unique Views: Request estimate from publisher';
export const SOV_BEFORE_TOOLTIP = 'Advertiser Share of Voice with that publisher prior to running the placement';
export const ACTUAL_SOV_AFTER_TOOLTIP = 'Advertiser Share of Voice with that publisher after running the placement';
export const CUSTOM_BASELINE_TOOLTIP = 'Average daily revenue without placement for that publisher (from the same month last year if auto-calculated baseline is used. If custom baseline is used, the user decides what timeframe the average daily revenue baseline is from.)';

export const CJ_MARKETPLACE_IO_TOOLTIP = 'IO (Insertion Order) number from CJ Marketplace';
export const PUBLISHER_IO_TOOLTIP = 'IO (Insertion Order) Number on the publisher\'s version of the IO';
export const IO_SIGNED_TOOLTIP = 'Status of the IO execution (has it been signed by both parties)';
export const PROGRAM_TERM_DESCRIPTION_TOOLTIP = 'Description of the Program Term the publisher should be on during' +
    ' the placement days';
export const PROGRAM_TERM_NAME_TOOLTIP = 'Exact name of the Program Term the publisher should be on during the placement days.';
export const PROGRAM_TERM_PUSHED_TOOLTIP = 'Status of whether the program term has been pushed';
export const ASSET_DUE_DATE_TOOLTIP = 'Last date for the submission of placement assets, dictated by each publisher via email/IO';
export const ASSETS_NEEDED_TOOLTIP = 'Detail what type of assets are needed for the placement, as dictated by the publisher via email/IO (Offer, Text Link or Banner/Image | for Banners - lifestyle or product image? Include client logo? Included call-to-action?)';
export const ASSETS_SENT_BY_ADVERTISER_TOOLTIP = 'The date when Advertiser sent the assets';
export const TIERED_OFFER_TOOLTIP = 'Explain the details of the tiered/spend-more-save-more offer';
export const OFFER_TYPE_TOOLTIP = 'The type of offer that is being used for this placement';
export const OFFER_VALUE_TOOLTIP = 'The value of the Offer Type. Should be numeric or integer e.g., For 25% Off, the Offer Value will be 25.';
export const OFFER_CONDITIONS_TOOLTIP = 'Specific conditions that must be met in order for the Offer to apply';
export const OFFER_THRESHOLD_TOOLTIP = 'The minimum order value for the offer to apply';
export const CASHBACK_AMOUNT_ONSITE_TOOLTIP = 'Cashback/Incentive amount that the consumer will see on the publisher\'s property';
export const LINK_ID_TOOLTIP = 'Link ID to be used for the placement given to publisher (if needed/if agreed to)';
export const CJ_INVOICE_MONTH_TOOLTIP = 'For invoiced clients: the month in which the placement flat fee will be charged to the Advertiser by CJ on the CJ invoice';
export const PUBLISHER_USED_LINK_ID_TOOLTIP = 'Has the pub used the link ID agreed to by both parties for this placement';
export const CORRECT_OFFER_USED_TOOLTIP = 'Track if correct offer was used';
export const OFFER_DESCRIPTION_TEXT_TOOLTIP = 'Offer text found live on the publisher\'s property when audit was performed';
export const PATH_TO_SAVED_EMAIL_TOOLTIP = 'Where to find stored screenshots of placements';
export const VALIDATION_NOTES_TOOLTIP = 'Notes taken while auditing live placements. Can be used to indicate steps taken when the wrong offer or cashback/incentive was showing on the publisher property';
export const PAID_IN_CJ_TOOLTIP = 'Status of the publisher payment';
export const PAYMENT_OID_TOOLTIP = 'OID for bonus payments & Transaction ID if paid from Placements Marketplace';
export const AMOUNT_PAID_TOOLTIP = 'Amount paid toward the placement flat fee';
export const PAYMENT_DATE_TOOLTIP = 'Date on which the last payment was made for the placement';
export const PAYMENT_NOTES_TOOLTIP = 'Notes about the payment(s) that have been made for the placement. It could include details of the currency conversion rate, if applicable.';

/*Column Header Tooltips*/
export const ACTUAL_CLICKS_TOOLTIP = 'Total clicks tracked during placement live dates';
export const ACTUAL_CR_TOOLTIP = 'The percentage of visits to a publisher’s website that converted to a sale or lead, during the placement live dates';
export const ACTUAL_INCREMENTAL_REVENUE_TOOLTIP = 'Incremental revenue tracked during placement live dates. Calculation: Actual Revenue from Insights – Projected Revenue w/o Placement';
export const ACTUAL_INCREMENTAL_ROAS_TOOLTIP = 'Incremental Return on Ad Spend tracked during placement live dates. Calculation: Actual Incremental Revenue divided by Actual Incremental Spend';
export const ACTUAL_INCREMENTAL_SPEND_TOOLTIP = 'Incremental costs tracked during placement live dates. Calculation: Actual Total Spend - Projected Spend w/o Placement';
export const ACTUAL_PLACEMENT_LIFT_TOOLTIP = 'Lift in Revenue due to Placement. Calculation: Actual Incremental Revenue/Projected Revenue without Placement.';
export const ACTUAL_REVENUE_TOOLTIP = 'Total revenue tracked during placement live dates';
export const ACTUAL_ROAS_TOOLTIP = 'Return on Ad Spend tracked during placement live dates. Calculation: Actual Revenue / Actual Total Spend';
export const ACTUAL_RPV_TOOLTIP = 'Revenue per visit tracked during placement live dates. Calculation: Actual Revenue / Actual Clicks';
export const ACTUAL_ACTION_COUNT_TOOLTIP = 'Total actions (sales/leads) tracked during the placement live dates';
export const ACTUAL_TOTAL_COMMISSIONS_TOOLTIP = 'Total commission tracked during placement live dates';
export const ACTUAL_TOTAL_SPEND_TOOLTIP = 'Total spend (sum of Actual Total Commissions and flat fee cost) tracked during placement live dates';
export const ADVERTISER_CID_TOOLTIP = 'Advertiser/Client Company ID';
export const ADVERTISER_NAME_TOOLTIP = 'Name of the Advertiser';
export const AUTO_CALCULATED_BASELINE_USED_TOOLTIP = 'Indicates if the baseline used is the auto calculated one';
export const CALENDAR_MONTH_TOOLTIP = 'Standard calendar month in which the placement ran or is scheduled to run';
export const CALENDAR_QUARTER_TOOLTIP = 'Standard calendar quarter in which the placement ran or is scheduled to run';
export const CALENDAR_WEEK_TOOLTIP = 'Standard calendar week in which the placement ran or is scheduled to run';
export const CALENDAR_YEAR_TOOLTIP = 'Standard calendar year in which the placement ran or is scheduled to run';
export const LAST_YEAR_COMM_FOR_SAME_DATES_TOOLTIP = 'LY Commissions tracked during placement run dates';
export const LAST_YEAR_REV_FOR_SAME_DATES_TOOLTIP = 'LY Revenue tracked during placement run dates';
export const PAST_3_MOS_CURRENT_YEAR_REVENUE_TOOLTIP = 'Total Revenue from the 3 month time period of current year';
export const PAST_3_MOS_CURRENT_YEAR_END_DATE_TOOLTIP = 'The end date of the past 3 month time period (past 3 months from placement creation date)';
export const PAST_3_MOS_CURRENT_YEAR_START_DATE_TOOLTIP = 'The start date of the past 3 month time period (past 3 months from placement creation date)';
export const PAST_3_MOS_LAST_YEAR_REVENUE_TOOLTIP = 'Total Revenue from the 3 month time period of last year';
export const PAST_3_MOS_LAST_YEAR_END_DATE_TOOLTIP = 'The end date of the past 3 month time period for last year (past 3 months from placement creation date, but in the previous year).';
export const PAST_3_MOS_LAST_YEAR_START_DATE_TOOLTIP = 'The start date of the past 3 month time period for last year (past 3 months from placement creation date, but in the previous year)';
export const PAST_3_MOS_YOY_OBSERVED_TOOLTIP = 'YOY % change in revenue for the publisher property for the 3 months prior to the placement creation date';
export const PLACEMENT_ID_TOOLTIP = 'Unique ID tied to that placement in Campaigns app (auto-generated by the app)';
export const PROJECTED_INCREMENTAL_REVENUE_TOOLTIP = 'Projected incremental revenue calculated for placement live dates. Calculation: Projected Revenue with Placement – Projected Revenue without Placement';
export const PROJECTED_INCREMENTAL_ROAS_TOOLTIP = 'Projected incremental ROAS calculated for placement live dates. Calculation: Projected Incremental Revenue/Projected Incremental Spend';
export const PROJECTED_INCREMENTAL_SPEND_TOOLTIP = 'Projected incremental spend calculated for placement live dates. Calculation: Projected Spend with Placement - Projected Spend without Placement';
export const PROJECTED_REVENUE_WITH_PLACEMENT_TOOLTIP = 'Projected revenue calculated for placement live dates with the placement running. Calculation: Baseline * Placement Duration * Organic Lift Over Baseline (%) * Expected Placement Lift Over Baseline(%) * Other Lift Over Baseline e.g. Sale(%)';
export const PROJECTED_REVENUE_WITHOUT_PLACEMENT_TOOLTIP = 'Projected revenue calculated for placement live dates if the placement was not running. Calculation: Baseline * Placement Duration * Organic Lift Over Baseline (%) * Other Lift Over Baseline e.g. Sale(%)';
export const PROJECTED_ROAS_TOOLTIP = 'Projected return on ad spend calculated for placement live dates with the placement running. Calculation: Projected Revenue with Placement / Projected Spend with Placement';
export const PROJECTED_SPEND_WITH_PLACEMENT_TOOLTIP = 'Projected spend calculated for placement live dates with the placement running. Calculation: (Projected Revenue with Placement * New Pub Commission) + Negotiated Flat Fee Cost';
export const PROJECTED_SPEND_WITHOUT_PLACEMENT_TOOLTIP = 'Projected spend calculated for placement live dates if the placement was not running. Calculation: Projected Revenue without Placement * Original Pub Commission';
export const PROPERTY_MODEL_TOOLTIP = 'Eg: Loyalty, Coupon, Content, etc';
export const PROPERTY_TYPE_TOOLTIP = 'Browser Extension, Website, etc.';
export const PUBLISHER_CID_TOOLTIP = 'Publisher Company ID';
export const PUBLISHER_NAME_TOOLTIP = 'Publisher Name';
export const REVENUE_ACCURACY_PROJECTED_ACTUALS_TOOLTIP = 'The percentage accuracy between the Actual and Projected revenue';
export const REVENUE_DELTA_PROJECTED_ACTUALS_TOOLTIP = 'The amount difference between the Actual and Projected revenue';
export const ROAS_ACCURACY_PROJECTED_ACTUALS_TOOLTIP = 'The percentage accuracy between the Actual and Projected ROAS';
export const WEBSITE_URL_TOOLTIP = 'URL of the publisher website where the placement or offer should be live';

export const EXCEL_SINGLE_SHEET_NAME = 'Placements';
export const EXCEL_SINGLE_SHEET_COLUMNS = [
    {key: "id", label: PLACEMENT_ID_LABEL},
    {key: "placementname", label: PLACEMENT_NAME},
    {key: "advertisercompanyid", label: ADVERTISER_CID_LABEL},
    {key: "advertisername", label: ADVERTISER_NAME_LABEL},
    {key: "startdate", label: START_DATE_LABEL},
    {key: "starttime", label: START_TIME_LABEL},
    {key: "enddate", label: END_DATE_LABEL},
    {key: "endtime", label: END_TIME_LABEL},
    {key: "timezone", label: ADVERTISER_TIMEZONE_LABEL},
    {key: "status", label: PLACEMENT_STATUS_LABEL},
    {key: "publishername", label: PUBLISHER_NAME_LABEL},
    {key: "publishercompanyid", label: PUBLISHER_CID_LABEL},
    {key: "publisherpropertyid", label: PUBLISHER_PROPERTY_TEXT_FIELD},
    {key: "placementtype", label: PLACEMENT_TYPE_LABEL},
    {key: "advertisercurrency", label: ADVERTISERS_FUNCTIONAL_CURRENCY_LABEL},
    {key: "calendaryear", label: CALENDAR_YEAR_LABEL},
    {key: "calendarqtr", label: CALENDAR_QTR_LABEL},
    {key: "calendarmonth", label: CALENDAR_MONTH_LABEL},
    {key: "calendarweek", label: CALENDAR_WEEK_LABEL},
    {key: "fiscalyear", label: FISCAL_YEAR_LABEL},
    {key: "fiscalquarter", label: FISCAL_QUARTER_LABEL},
    {key: "fiscalmonth", label: FISCAL_MONTH_LABEL},
    {key: "fiscalweek", label: FISCAL_WEEK_LABEL},
    {key: "websiteurl", label: WEBSITE_URL_LABEL},
    {key: "propertytype", label: PROPERTY_TYPE_LABEL},
    {key: "propertymodel", label: PROPERTY_MODEL_LABEL},
    {key: "personalizedortargeted", label: PERSONALIZED_TARGETED_LABEL},
    {key: "dynamicorstatic", label: DYNAMIC_STATIC_LABEL},
    {key: "rankofplacement", label: RANK_OR_SPOT_NUMBER_OF_PLACEMENT_TEXT_FIELD},
    {key: "event", label: EVENTS_LABEL},
    {key: "performancesendsizeexpecteduniquevalues", label: SEND_SIZE_LABEL},
    {key: "packagename", label: PACKAGE_NAME_LABEL},
    {key: "neworcompedplacement", label: NEW_OR_COMPED_LABEL},
    {key: "vipcontent", label: VIP_CONTENT_LABEL},
    {key: "proposedofferuseddescription", label: PROPOSED_OFFER_USED_DESCRIPTION_TEXT_FIELD},
    {key: "performancesovbefore", label: SOV_BEFORE_LABEL},
    {key: "lastyearsactualrevenue", label: LAST_YEAR_ACTUAL_REVENUE_LABEL},
    {key: "lastyearsactualcommissions", label: LAST_YEAR_ACTUAL_COMMISSION_LABEL},
    {key: "yoyquarterstartdatecurrentyear", label: YOY_QUARTER_START_DATE_CURRENT_YEAR_LABEL},
    {key: "yoyquarterenddatecurrentyear", label: YOY_QUARTER_END_DATE_CURRENT_YEAR_LABEL},
    {key: "yoyquarterstartdatelastyear", label: YOY_QUARTER_START_DATE_LAST_YEAR_LABEL},
    {key: "yoyquarterenddatelastyear", label: YOY_QUARTER_END_DATE_LAST_YEAR_LABEL},
    {key: "yearoveryearlastyearrevenue", label: YOY_CALCULATION_LAST_YEAR_REVENUE_LABEL},
    {key: "yearoveryearcurrentyearrevenue", label: YOY_CALCULATION_CURRENT_YEAR_REVENUE_LABEL},
    {key: "yearoveryearobserved", label: YOY_OBSERVED_PERCENTAGE_LABEL},
    {key: "performanceoriginalpublishercommission", label: ORIGINAL_PUBLISHER_COMMISSION_LABEL},
    {key: "performancenewpublishercommission", label: NEW_PUBLISHER_COMMISSION_LABEL},
    {key: "performanceoriginalratecardflatfeeprice", label: ORIGINAL_FLAT_FEE_LABEL},
    {key: "performancecjnegotiatedflatfeecost", label: CJ_FLAT_FEE_LABEL},
    {key: "performanceyoygrowthtrendused", label: YOY_GROWTH_TREND_LABEL},
    {key: "performancepredictedplacementlift", label: PRIOR_PLACEMENT_LIFT_LABEL},
    {key: "performanceotherexpectedlift", label: OTHER_EXPECTED_LIFT_LABEL},
    {key: "averagebaselinerevenue", label: AVERAGE_DAILY_REVENUE_BASELINE_LABEL},
    {key: "isbaselinecalculated", label: CALCULATED_BASELINE_USED_LABEL},
    {key: "projectedspendwithplacement", label: PROJECTED_SPEND_WITH_PLACEMENT_LABEL},
    {key: "projectedspendwithoutplacement", label: PROJECTED_SPEND_WITHOUT_PLACEMENT_LABEL},
    {key: "projectedrevenuewithplacement", label: PROJECTED_REVENUE_WITH_PLACEMENT_LABEL},
    {key: "projectedrevenuewithoutplacement", label: PROJECTED_REVENUE_WITHOUT_PLACEMENT_LABEL},
    {key: "projectedreturnonadspend", label: PROJECTED_ROAS_LABEL},
    {key: "projectedincrementalrevenue", label: PROJECTED_INCREMENTAL_REVENUE_LABEL},
    {key: "projectedincrementalspend", label: PROJECTED_INCREMENTAL_SPEND_LABEL},
    {key: "projectedincrementalreturnonadspend", label: PROJECTED_INCREMENTAL_ROAS_LABEL},
    {key: "actualrevenue", label: ACTUAL_REVENUE_LABEL},
    {key: "actualincrementalrevenue", label: ACTUAL_INCREMENTAL_REVENUE_LABEL},
    {key: "actualtotalcommissions", label: ACTUAL_TOTAL_COMMISSIONS_LABEL},
    {key: "actualtotalspend", label: ACTUAL_TOTAL_SPEND_LABEL},
    {key: "actualincrementalspend", label: ACTUAL_INCREMENTAL_SPEND_LABEL},
    {key: "actualreturnonadspend", label: ACTUAL_ROAS_LABEL},
    {key: "actualincrementalreturnonadspend", label: ACTUAL_INCREMENTAL_ROAS_LABEL},
    {key: "actualclicks", label: ACTUAL_CLICKS_LABEL},
    {key: "actualrevenuepervisits", label: ACTUAL_RPV_LABEL},
    {key: "actualsales", label: ACTUAL_SALES_LABEL},
    {key: "actualnumberofsalesgeneratedperclick", label: ACTUAL_CR_LABEL},
    {key: "actualplacementlift", label: ACTUAL_PLACEMENT_LIFT_LABEL},
    {key: "revenuedelta", label: REVENUE_DELTA_LABEL},
    {key: "revenueaccuracy", label: REVENUE_ACCURACY_LABEL},
    {key: "returnonadspendaccuracy", label: ROAS_ACCURACY_LABEL},
    {key: "performanceactualsovafter", label: ACTUAL_SOV_AFTER_LABEL},
    {key: "bookingcjmarketplaceinsertionordernumber", label: CJ_MARKETPLACE_IO_LABEL},
    {key: "bookingotherinsertionordernumber", label: PUBLISHER_IO_LABEL},
    {key: "bookinginsertionordersignedindicator", label: IO_SIGNED_LABEL},
    {key: "bookingprogramtermdescription", label: PROGRAM_TERM_DESCRIPTION_LABEL},
    {key: "bookingprogramtermname", label: PROGRAM_TERM_NAME_LABEL},
    {key: "bookingprogramtermspushedindicator", label: PROGRAM_TERM_PUSHED_LABEL},
    {key: "bookinglinkid", label: LINK_ID_LABEL},
    {key: "bookingassetsneeded", label: ASSETS_NEEDED_LABEL},
    {key: "bookingassetduedate", label: ASSET_DUE_DATE_LABEL},
    {key: "bookingassetssenttoadvertiser", label: ASSETS_SENT_BY_ADVERTISER_LABEL},
    {key: "bookingoffertype", label: OFFER_TYPE_LABEL},
    {key: "bookingoffervalue", label: OFFER_VALUE_LABEL},
    {key: "bookingofferconditions", label: OFFER_CONDITIONS_LABEL},
    {key: "bookingofferthreshold", label: OFFER_THRESHOLD_LABEL},
    {key: "bookingtieredoffer", label: TIERED_OFFER_LABEL},
    {key: "bookingcashbackorincentiveamountonsite", label: CASHBACK_AMOUNT_ONSITE_LABEL},
    {key: "bookinginvoicemonth", label: CJ_INVOICE_MONTH_LABEL},
    {key: "publisherusedspecifiedlinkid", label: PUBLISHER_USED_LINK_ID_LABEL},
    {key: "description", label: OFFER_DESCRIPTION_TEXT_LABEL},
    {key: "wascorrectofferused", label: CORRECT_OFFER_USED_LABEL},
    {key: "screenshotlink", label: PATH_TO_SAVED_EMAIL_LABEL},
    {key: "validationnotes", label: VALIDATION_NOTES_LABEL},
    {key: "paidincj", label: PAID_IN_CJ_LABEL},
    {key: "transactiondate", label: PAYMENT_DATE_LABEL},
    {key: "transactionid", label: PAYMENT_OID_LABEL},
    {key: "amount", label: AMOUNT_PAID_LABEL},
    {key: "notes", label: PAYMENT_NOTES_LABEL},
    {key: "placementcreated", label: PLACEMENT_CREATION_DATE_TIME_LABEL},
    {key: "placementcreatedby", label: PLACEMENT_CREATED_BY_LABEL},
    {key: "forecastlastupdated", label: PERFORMANCE_LAST_UPDATED_ON_LABEL},
    {key: "validationcreated", label: VALIDATION_DETAILS_CREATED_ON_LABEL},
    {key: "validationcreatedby", label: VALIDATION_DETAILS_CREATED_BY_LABEL},
    {key: "validationlastupdated", label: VALIDATION_DETAILS_LAST_UPDATED_ON_LABEL},
    {key: "validationlastupdatedby", label: VALIDATION_DETAILS_LAST_UPDATED_BY_LABEL},
    {key: "paymentcreated", label: PAYMENT_DETAILS_CREATED_ON_LABEL},
    {key: "paymentcreatedby", label: PAYMENT_DETAILS_CREATED_BY_LABEL},
    {key: "paymentlastupdated", label: PAYMENT_DETAILS_LAST_UPDATED_ON_LABEL},
    {key: "paymentlastupdatedby", label: PAYMENT_DETAILS_LAST_UPDATED_BY_LABEL}
];

export const EXCEL_MULTI_SHEET1_NAME = 'Placement Projections';
export const EXCEL_MULTI_SHEET2_NAME = 'Placement Performance';
export const EXCEL_MULTI_SHEET3_NAME = 'Placement Audit & Payment';
export const EXCEL_MULTI_SHEET1_COLUMNS = [
    {key: "id", label: PLACEMENT_ID_LABEL},
    {key: "placementname", label: PLACEMENT_NAME},
    {key: "advertisercompanyid", label: ADVERTISER_CID_LABEL},
    {key: "advertisername", label: ADVERTISER_NAME_LABEL},
    {key: "startdate", label: START_DATE_LABEL},
    {key: "starttime", label: START_TIME_LABEL},
    {key: "enddate", label: END_DATE_LABEL},
    {key: "endtime", label: END_TIME_LABEL},
    {key: "timezone", label: ADVERTISER_TIMEZONE_LABEL},
    {key: "status", label: PLACEMENT_STATUS_LABEL},
    {key: "publishername", label: PUBLISHER_NAME_LABEL},
    {key: "publishercompanyid", label: PUBLISHER_CID_LABEL},
    {key: "publisherpropertyid", label: PUBLISHER_PROPERTY_TEXT_FIELD},
    {key: "placementtype", label: PLACEMENT_TYPE_LABEL},
    {key: "advertisercurrency", label: ADVERTISERS_FUNCTIONAL_CURRENCY_LABEL},
    {key: "calendaryear", label: CALENDAR_YEAR_LABEL},
    {key: "calendarqtr", label: CALENDAR_QTR_LABEL},
    {key: "calendarmonth", label: CALENDAR_MONTH_LABEL},
    {key: "calendarweek", label: CALENDAR_WEEK_LABEL},
    {key: "fiscalyear", label: FISCAL_YEAR_LABEL},
    {key: "fiscalquarter", label: FISCAL_QUARTER_LABEL},
    {key: "fiscalmonth", label: FISCAL_MONTH_LABEL},
    {key: "fiscalweek", label: FISCAL_WEEK_LABEL},
    {key: "websiteurl", label: WEBSITE_URL_LABEL},
    {key: "propertytype", label: PROPERTY_TYPE_LABEL},
    {key: "propertymodel", label: PROPERTY_MODEL_LABEL},
    {key: "personalizedortargeted", label: PERSONALIZED_TARGETED_LABEL},
    {key: "dynamicorstatic", label: DYNAMIC_STATIC_LABEL},
    {key: "rankofplacement", label: RANK_OR_SPOT_NUMBER_OF_PLACEMENT_TEXT_FIELD},
    {key: "event", label: EVENTS_LABEL},
    {key: "performancesendsizeexpecteduniquevalues", label: SEND_SIZE_LABEL},
    {key: "packagename", label: PACKAGE_NAME_LABEL},
    {key: "neworcompedplacement", label: NEW_OR_COMPED_LABEL},
    {key: "vipcontent", label: VIP_CONTENT_LABEL},
    {key: "proposedofferuseddescription", label: PROPOSED_OFFER_USED_DESCRIPTION_TEXT_FIELD},
    {key: "performancesovbefore", label: SOV_BEFORE_LABEL},
    {key: "lastyearsactualrevenue", label: LAST_YEAR_ACTUAL_REVENUE_LABEL},
    {key: "lastyearsactualcommissions", label: LAST_YEAR_ACTUAL_COMMISSION_LABEL},
    {key: "yoyquarterstartdatecurrentyear", label: YOY_QUARTER_START_DATE_CURRENT_YEAR_LABEL},
    {key: "yoyquarterenddatecurrentyear", label: YOY_QUARTER_END_DATE_CURRENT_YEAR_LABEL},
    {key: "yoyquarterstartdatelastyear", label: YOY_QUARTER_START_DATE_LAST_YEAR_LABEL},
    {key: "yoyquarterenddatelastyear", label: YOY_QUARTER_END_DATE_LAST_YEAR_LABEL},
    {key: "yearoveryearlastyearrevenue", label: YOY_CALCULATION_LAST_YEAR_REVENUE_LABEL},
    {key: "yearoveryearcurrentyearrevenue", label: YOY_CALCULATION_CURRENT_YEAR_REVENUE_LABEL},
    {key: "yearoveryearobserved", label: YOY_OBSERVED_PERCENTAGE_LABEL},
    {key: "performanceoriginalpublishercommission", label: ORIGINAL_PUBLISHER_COMMISSION_LABEL},
    {key: "performancenewpublishercommission", label: NEW_PUBLISHER_COMMISSION_LABEL},
    {key: "performanceoriginalratecardflatfeeprice", label: ORIGINAL_FLAT_FEE_LABEL},
    {key: "performancecjnegotiatedflatfeecost", label: CJ_FLAT_FEE_LABEL},
    {key: "performanceyoygrowthtrendused", label: YOY_GROWTH_TREND_LABEL},
    {key: "performancepredictedplacementlift", label: PRIOR_PLACEMENT_LIFT_LABEL},
    {key: "performanceotherexpectedlift", label: OTHER_EXPECTED_LIFT_LABEL},
    {key: "averagebaselinerevenue", label: AVERAGE_DAILY_REVENUE_BASELINE_LABEL},
    {key: "isbaselinecalculated", label: CALCULATED_BASELINE_USED_LABEL},
    {key: "projectedspendwithplacement", label: PROJECTED_SPEND_WITH_PLACEMENT_LABEL},
    {key: "projectedspendwithoutplacement", label: PROJECTED_SPEND_WITHOUT_PLACEMENT_LABEL},
    {key: "projectedrevenuewithplacement", label: PROJECTED_REVENUE_WITH_PLACEMENT_LABEL},
    {key: "projectedrevenuewithoutplacement", label: PROJECTED_REVENUE_WITHOUT_PLACEMENT_LABEL},
    {key: "projectedreturnonadspend", label: PROJECTED_ROAS_LABEL},
    {key: "projectedincrementalrevenue", label: PROJECTED_INCREMENTAL_REVENUE_LABEL},
    {key: "projectedincrementalspend", label: PROJECTED_INCREMENTAL_SPEND_LABEL},
    {key: "projectedincrementalreturnonadspend", label: PROJECTED_INCREMENTAL_ROAS_LABEL},
    {key: "placementcreated", label: PLACEMENT_CREATION_DATE_TIME_LABEL},
    {key: "placementcreatedby", label: PLACEMENT_CREATED_BY_LABEL}
]
export const EXCEL_MULTI_SHEET2_COLUMNS = [
    {key: "id", label: PLACEMENT_ID_LABEL},
    {key: "placementname", label: PLACEMENT_NAME},
    {key: "advertisercompanyid", label: ADVERTISER_CID_LABEL},
    {key: "advertisername", label: ADVERTISER_NAME_LABEL},
    {key: "startdate", label: START_DATE_LABEL},
    {key: "starttime", label: START_TIME_LABEL},
    {key: "enddate", label: END_DATE_LABEL},
    {key: "endtime", label: END_TIME_LABEL},
    {key: "timezone", label: ADVERTISER_TIMEZONE_LABEL},
    {key: "status", label: PLACEMENT_STATUS_LABEL},
    {key: "publishername", label: PUBLISHER_NAME_LABEL},
    {key: "publishercompanyid", label: PUBLISHER_CID_LABEL},
    {key: "publisherpropertyid", label: PUBLISHER_PROPERTY_TEXT_FIELD},
    {key: "placementtype", label: PLACEMENT_TYPE_LABEL},
    {key: "advertisercurrency", label: ADVERTISERS_FUNCTIONAL_CURRENCY_LABEL},
    {key: "calendaryear", label: CALENDAR_YEAR_LABEL},
    {key: "calendarqtr", label: CALENDAR_QTR_LABEL},
    {key: "calendarmonth", label: CALENDAR_MONTH_LABEL},
    {key: "calendarweek", label: CALENDAR_WEEK_LABEL},
    {key: "fiscalyear", label: FISCAL_YEAR_LABEL},
    {key: "fiscalquarter", label: FISCAL_QUARTER_LABEL},
    {key: "fiscalmonth", label: FISCAL_MONTH_LABEL},
    {key: "fiscalweek", label: FISCAL_WEEK_LABEL},
    {key: "websiteurl", label: WEBSITE_URL_LABEL},
    {key: "propertymodel", label: PROPERTY_MODEL_LABEL},
    {key: "personalizedortargeted", label: PERSONALIZED_TARGETED_LABEL},
    {key: "dynamicorstatic", label: DYNAMIC_STATIC_LABEL},
    {key: "rankofplacement", label: RANK_OR_SPOT_NUMBER_OF_PLACEMENT_TEXT_FIELD},
    {key: "event", label: EVENTS_LABEL},
    {key: "performancesendsizeexpecteduniquevalues", label: SEND_SIZE_LABEL},
    {key: "packagename", label: PACKAGE_NAME_LABEL},
    {key: "neworcompedplacement", label: NEW_OR_COMPED_LABEL},
    {key: "vipcontent", label: VIP_CONTENT_LABEL},
    {key: "proposedofferuseddescription", label: PROPOSED_OFFER_USED_DESCRIPTION_TEXT_FIELD},
    {key: "performanceoriginalpublishercommission", label: ORIGINAL_PUBLISHER_COMMISSION_LABEL},
    {key: "performancenewpublishercommission", label: NEW_PUBLISHER_COMMISSION_LABEL},
    {key: "performanceoriginalratecardflatfeeprice", label: ORIGINAL_FLAT_FEE_LABEL},
    {key: "performancecjnegotiatedflatfeecost", label: CJ_FLAT_FEE_LABEL},
    {key: "bookingcjmarketplaceinsertionordernumber", label: CJ_MARKETPLACE_IO_LABEL},
    {key: "bookingotherinsertionordernumber", label: PUBLISHER_IO_LABEL},
    {key: "bookinginsertionordersignedindicator", label: IO_SIGNED_LABEL},
    {key: "bookingprogramtermdescription", label: PROGRAM_TERM_DESCRIPTION_LABEL},
    {key: "bookingprogramtermname", label: PROGRAM_TERM_NAME_LABEL},
    {key: "bookingprogramtermspushedindicator", label: PROGRAM_TERM_PUSHED_LABEL},
    {key: "bookinglinkid", label: LINK_ID_LABEL},
    {key: "bookingassetsneeded", label: ASSETS_NEEDED_LABEL},
    {key: "bookingassetduedate", label: ASSET_DUE_DATE_LABEL},
    {key: "bookingassetssenttoadvertiser", label: ASSETS_SENT_BY_ADVERTISER_LABEL},
    {key: "bookingoffertype", label: OFFER_TYPE_LABEL},
    {key: "bookingoffervalue", label: OFFER_VALUE_LABEL},
    {key: "bookingofferconditions", label: OFFER_CONDITIONS_LABEL},
    {key: "bookingofferthreshold", label: OFFER_THRESHOLD_LABEL},
    {key: "bookingtieredoffer", label: TIERED_OFFER_LABEL},
    {key: "bookingcashbackorincentiveamountonsite", label: CASHBACK_AMOUNT_ONSITE_LABEL},
    {key: "bookinginvoicemonth", label: CJ_INVOICE_MONTH_LABEL},
    {key: "performancesovbefore", label: SOV_BEFORE_LABEL},
    {key: "lastyearsactualrevenue", label: LAST_YEAR_ACTUAL_REVENUE_LABEL},
    {key: "lastyearsactualcommissions", label: LAST_YEAR_ACTUAL_COMMISSION_LABEL},
    {key: "projectedspendwithplacement", label: PROJECTED_SPEND_WITH_PLACEMENT_LABEL},
    {key: "projectedrevenuewithplacement", label: PROJECTED_REVENUE_WITH_PLACEMENT_LABEL},
    {key: "projectedreturnonadspend", label: PROJECTED_ROAS_LABEL},
    {key: "projectedincrementalrevenue", label: PROJECTED_INCREMENTAL_REVENUE_LABEL},
    {key: "projectedincrementalspend", label: PROJECTED_INCREMENTAL_SPEND_LABEL},
    {key: "projectedincrementalreturnonadspend", label: PROJECTED_INCREMENTAL_ROAS_LABEL},
    {key: "actualrevenue", label: ACTUAL_REVENUE_LABEL},
    {key: "actualincrementalrevenue", label: ACTUAL_INCREMENTAL_REVENUE_LABEL},
    {key: "actualtotalcommissions", label: ACTUAL_TOTAL_COMMISSIONS_LABEL},
    {key: "actualtotalspend", label: ACTUAL_TOTAL_SPEND_LABEL},
    {key: "actualincrementalspend", label: ACTUAL_INCREMENTAL_SPEND_LABEL},
    {key: "actualreturnonadspend", label: ACTUAL_ROAS_LABEL},
    {key: "actualincrementalreturnonadspend", label: ACTUAL_INCREMENTAL_ROAS_LABEL},
    {key: "actualclicks", label: ACTUAL_CLICKS_LABEL},
    {key: "actualrevenuepervisits", label: ACTUAL_RPV_LABEL},
    {key: "actualsales", label: ACTUAL_SALES_LABEL},
    {key: "actualnumberofsalesgeneratedperclick", label: ACTUAL_CR_LABEL},
    {key: "actualplacementlift", label: ACTUAL_PLACEMENT_LIFT_LABEL},
    {key: "performanceactualsovafter", label: ACTUAL_SOV_AFTER_LABEL},
    {key: "revenuedelta", label: REVENUE_DELTA_LABEL},
    {key: "revenueaccuracy", label: REVENUE_ACCURACY_LABEL},
    {key: "returnonadspendaccuracy", label: ROAS_ACCURACY_LABEL},
    {key: "placementcreated", label: PLACEMENT_CREATION_DATE_TIME_LABEL},
    {key: "placementcreatedby", label: PLACEMENT_CREATED_BY_LABEL},
    {key: "forecastlastupdated", label: PERFORMANCE_LAST_UPDATED_ON_LABEL},
]
export const EXCEL_MULTI_SHEET3_COLUMNS = [
    {key: "id", label: PLACEMENT_ID_LABEL},
    {key: "placementname", label: PLACEMENT_NAME},
    {key: "advertisercompanyid", label: ADVERTISER_CID_LABEL},
    {key: "advertisername", label: ADVERTISER_NAME_LABEL},
    {key: "startdate", label: START_DATE_LABEL},
    {key: "starttime", label: START_TIME_LABEL},
    {key: "enddate", label: END_DATE_LABEL},
    {key: "endtime", label: END_TIME_LABEL},
    {key: "timezone", label: ADVERTISER_TIMEZONE_LABEL},
    {key: "status", label: PLACEMENT_STATUS_LABEL},
    {key: "publishername", label: PUBLISHER_NAME_LABEL},
    {key: "publishercompanyid", label: PUBLISHER_CID_LABEL},
    {key: "publisherpropertyid", label: PUBLISHER_PROPERTY_TEXT_FIELD},
    {key: "placementtype", label: PLACEMENT_TYPE_LABEL},
    {key: "advertisercurrency", label: ADVERTISERS_FUNCTIONAL_CURRENCY_LABEL},
    {key: "calendaryear", label: CALENDAR_YEAR_LABEL},
    {key: "calendarqtr", label: CALENDAR_QTR_LABEL},
    {key: "calendarmonth", label: CALENDAR_MONTH_LABEL},
    {key: "calendarweek", label: CALENDAR_WEEK_LABEL},
    {key: "fiscalyear", label: FISCAL_YEAR_LABEL},
    {key: "fiscalquarter", label: FISCAL_QUARTER_LABEL},
    {key: "fiscalmonth", label: FISCAL_MONTH_LABEL},
    {key: "fiscalweek", label: FISCAL_WEEK_LABEL},
    {key: "websiteurl", label: WEBSITE_URL_LABEL},
    {key: "propertymodel", label: PROPERTY_MODEL_LABEL},
    {key: "personalizedortargeted", label: PERSONALIZED_TARGETED_LABEL},
    {key: "dynamicorstatic", label: DYNAMIC_STATIC_LABEL},
    {key: "rankofplacement", label: RANK_OR_SPOT_NUMBER_OF_PLACEMENT_TEXT_FIELD},
    {key: "event", label: EVENTS_LABEL},
    {key: "packagename", label: PACKAGE_NAME_LABEL},
    {key: "neworcompedplacement", label: NEW_OR_COMPED_LABEL},
    {key: "vipcontent", label: VIP_CONTENT_LABEL},
    {key: "proposedofferuseddescription", label: PROPOSED_OFFER_USED_DESCRIPTION_TEXT_FIELD},
    {key: "performanceoriginalpublishercommission", label: ORIGINAL_PUBLISHER_COMMISSION_LABEL},
    {key: "performancenewpublishercommission", label: NEW_PUBLISHER_COMMISSION_LABEL},
    {key: "performanceoriginalratecardflatfeeprice", label: ORIGINAL_FLAT_FEE_LABEL},
    {key: "performancecjnegotiatedflatfeecost", label: CJ_FLAT_FEE_LABEL},
    {key: "bookingoffertype", label: OFFER_TYPE_LABEL},
    {key: "bookingoffervalue", label: OFFER_VALUE_LABEL},
    {key: "bookingofferconditions", label: OFFER_CONDITIONS_LABEL},
    {key: "bookingofferthreshold", label: OFFER_THRESHOLD_LABEL},
    {key: "bookingtieredoffer", label: TIERED_OFFER_LABEL},
    {key: "bookingcashbackorincentiveamountonsite", label: CASHBACK_AMOUNT_ONSITE_LABEL},
    {key: "bookinginvoicemonth", label: CJ_INVOICE_MONTH_LABEL},
    {key: "wascorrectofferused", label: CORRECT_OFFER_USED_LABEL},
    {key: "description", label: OFFER_DESCRIPTION_TEXT_LABEL},
    {key: "publisherusedspecifiedlinkid", label: PUBLISHER_USED_LINK_ID_LABEL},
    {key: "screenshotlink", label: PATH_TO_SAVED_EMAIL_LABEL},
    {key: "validationnotes", label: VALIDATION_NOTES_LABEL},
    {key: "validationcreated", label: VALIDATION_DETAILS_CREATED_ON_LABEL},
    {key: "validationcreatedby", label: VALIDATION_DETAILS_CREATED_BY_LABEL},
    {key: "validationlastupdated", label: VALIDATION_DETAILS_LAST_UPDATED_ON_LABEL},
    {key: "validationlastupdatedby", label: VALIDATION_DETAILS_LAST_UPDATED_BY_LABEL},
    {key: "paidincj", label: PAID_IN_CJ_LABEL},
    {key: "transactionid", label: PAYMENT_OID_LABEL},
    {key: "transactiondate", label: PAYMENT_DATE_LABEL},
    {key: "amount", label: AMOUNT_PAID_LABEL},
    {key: "notes", label: PAYMENT_NOTES_LABEL},
    {key: "paymentcreated", label: PAYMENT_DETAILS_CREATED_ON_LABEL},
    {key: "paymentcreatedby", label: PAYMENT_DETAILS_CREATED_BY_LABEL},
    {key: "paymentlastupdated", label: PAYMENT_DETAILS_LAST_UPDATED_ON_LABEL},
    {key: "paymentlastupdatedby", label: PAYMENT_DETAILS_LAST_UPDATED_BY_LABEL}
]

export const tabErrorMessages = {
    'bookingdetails': BOOKING_DETAILS_ERROR_MESSAGE,
    'validationDetails': VALIDATION_DETAILS_ERROR_MESSAGE,
    'paymentDetails': PAYMENT_DETAILS_ERROR_MESSAGE
};
export const tabs = ["validationDetails", "bookingdetails", "paymentDetails"];

export const detailsTab = [
    {getKey: "placementname", formKey: 'placementName'},
    {getKey: STATUS, formKey: 'placementStatusId'},
    {getKey: "startdate", formKey: 'pStartDate'},
    {getKey: "enddate", formKey: 'pEndDate'},
    {getKey: "packagename", formKey: 'packageName'},
    {getKey: "placementtype", formKey: 'placementType'},
    {getKey: "dynamicorstatic", formKey: 'dynamicOrStatic'},
    {getKey: "personalizedortargeted", formKey: 'personalizedOrTargeted'},
    {getKey: "neworcompedplacement", formKey: 'newOrComped'},
    {getKey: "vipcontent", formKey: 'vipContentCampaign'},
    {getKey: "rankofplacement", formKey: 'rankofplacement'},
    {getKey: "event", formKey: 'events'},
    {getKey: "proposedofferuseddescription", formKey: 'proposedOfferDescription'},
    {getKey: "paymentid", formKey: 'paymentid'},
    {getKey: "validationid", formKey: 'validationid'},
    {getKey: "fiscalyear", formKey: 'fiscalYear'},
    {getKey: "fiscalquarter", formKey: 'fiscalQuarter'},
    {getKey: "fiscalmonth", formKey: 'fiscalMonth'},
    {getKey: "fiscalweek", formKey: 'fiscalWeek'},
]

export const detailsTabPID = [
    {getKey: "publisherpropertyid", formKey: 'publisherPropertyId'},
    {getKey: "publishercompanyid", formKey: 'publisherCompanyId'},
    {getKey: "propertymodel", formKey: 'propertyModel'},
    {getKey: "websiteurl", formKey: 'websiteUrl'},
    {getKey: "publishername", formKey: 'publisherName'},
    {getKey: "propertytype", formKey: 'propertyType'},
    {getKey: "propertyname", formKey: 'propertyName'},
]

export const detailsTabAdvertiser = [
    {getKey: "advertisercompanyid", formKey: "value"},
    {getKey: "advertisername", formKey: "companyName"}
]

export const bookingdetails = [
    {getKey: 'bookingcjmarketplaceinsertionordernumber', formKey: 'bookingmarketinsertionorder'},
    {getKey: 'bookingotherinsertionordernumber', formKey: 'bookingotherio'},
    {getKey: 'bookinginsertionordersignedindicator', formKey: 'bookingissigned'},
    {getKey: 'bookingprogramtermname', formKey: 'bookingprogramtermname'},
    {getKey: 'bookingprogramtermspushedindicator', formKey: 'bookingispushed'},
    {getKey: 'bookinglinkid', formKey: 'bookinglinkid'},
    {getKey: 'bookingassetduedate', formKey: 'bookingduedate'},
    {getKey: 'bookingassetsneeded', formKey: 'bookingassetsneeded'},
    {getKey: 'bookingassetssenttoadvertiser', formKey: 'bookingassetsentdate'},
    {getKey: 'bookingcashbackorincentiveamountonsite', formKey: 'bookingincentiveamount'},
    {getKey: 'bookingtieredoffer', formKey: 'bookingtieredoffer'},
    {getKey: 'bookingoffertype', formKey: 'bookingoffertype'},
    {getKey: 'bookingoffervalue', formKey: 'bookingoffervalue'},
    {getKey: 'bookingofferconditions', formKey: 'bookingoffercondition'},
    {getKey: 'bookingofferthreshold', formKey: 'bookingofferthreshold'},
    {getKey: 'bookingprogramtermdescription', formKey: 'bookingprogramtermdescription'},
    {getKey: 'bookinginvoicemonth', formKey: 'bookinginvoicemonth'},
]

export const validationTabDetails = [
    {getKey: "publisherusedspecifiedlinkid", formKey: 'publisherusedspecifiedlinkid'},
    {getKey: "wascorrectofferused", formKey: 'wascorrectofferused'},
    {getKey: "description", formKey: 'description'},
    {getKey: "screenshotlink", formKey: 'screenshotlink'},
    {getKey: "validationnotes", formKey: 'validationnotes'}
]

export const paymentTabDetails = [
    {getKey: "amount", formKey: 'amount'},
    {getKey: "notes", formKey: 'notes'},
    {getKey: "paidincj", formKey: 'paidInCJ'},
    {getKey: "transactiondate", formKey: 'transactiondate'},
    {getKey: "transactionid", formKey: 'transactionid'}
]

export const performanceTabDetails = [
    {getKey: "performanceactualsovafter", formKey: "performanceActualSovAfter"},
    {getKey: "performancecjnegotiatedflatfeecost", formKey: "performanceCjNegotiatedFlatFeeCost"},
    {getKey: "performancenewpublishercommission", formKey: "performanceNewPublisherCommission"},
    {getKey: "performanceoriginalpublishercommission", formKey: "performanceOriginalPublisherCommission"},
    {getKey: "performanceoriginalratecardflatfeeprice", formKey: "performanceOriginalRateCardFlatFeePrice"},
    {getKey: "performanceotherexpectedlift", formKey: "performanceOtherExpectedLift"},
    {getKey: "performancepredictedplacementlift", formKey: "performancePredictedPlacementLift"},
    {getKey: "performancesendsizeexpecteduniquevalues", formKey: "performanceSendSizeExpectedUniqueValues"},
    {getKey: "performancesovbefore", formKey: "performanceSovBefore"},
    {getKey: "performanceyoygrowthtrendused", formKey: "performanceyoygrowthtrendused"},
    {getKey: "baselineValue", formKey: "baselineValue"}
]

export const forecastPerformanceDetails = [
    {getKey: "yearoveryearlastyearrevenue", formKey: "yearOverYearLastYearRevenue"},
    {getKey: "yearoveryearcurrentyearrevenue", formKey: "yearOverYearCurrentYearRevenue"},
    {getKey: "yoyquarterstartdatelastyear", formKey: "yoyQuarterStartDateLastYear"},
    {getKey: "yoyquarterenddatelastyear", formKey: "yoyQuarterEndDateLastYear"},
    {getKey: "yoyquarterstartdatecurrentyear", formKey: "yoyQuarterStartDateCurrentYear"},
    {getKey: "yoyquarterenddatecurrentyear", formKey: "yoyQuarterEndDateCurrentYear"},
    {getKey: "yearOverYearObserved", formKey: "yearOverYearObserved"}
]

/* Filter Panel Section */
export const CLEAR_ALL = " CLEAR ALL";
export const ADVERTISERS = 'Advertisers';
export const PUBLISHERS = 'Publishers';
export const PLACEMENT_MODE_BULK_UPLOAD = 'bulk-upload-mode';
export const PLACEMENT_MODE_CREATE = 'create-mode';
export const PLACEMENT_MODE_EDIT = 'edit-mode';
export const PLACEMENT_MODE_DUPLICATE = 'duplicate-mode';
export const PLACEMENT_MODE_REMOVE = 'remove-mode';

/*Date Filter */
export const DATE_FILTER_APPLY = "APPLY";
export const DATE_FILTER_CANCEL = "CANCEL";
export const DATE_FILTER_START_DATE = "2016-01-01"
export const PREDEFINED_RANGES_LABEL = 'Base Period';
export const NO_LOCALE = "";
export const PLACEMENT_RUN_DATE = "Placement Run Date";
export const TODAY = "Today";
export const YESTERDAY = "Yesterday";
export const THIS_WEEK = "This Week";
export const LAST_WEEK = "Last Week";
export const THIS_MONTH = "This Month";
export const LAST_MONTH = "Last Month";
export const NEXT_QUARTER = "Next Quarter";
export const THIS_QUARTER = "This Quarter";
export const LAST_QUARTER = "Last Quarter";
export const THIS_YEAR = "This Year";
export const LAST_YEAR = "Last Year";
export const CUSTOM = "Custom";

/*Publisher Filter */
export const NO_MATCHES_FOUND = "No matches found";
export const TYPE_TO_SEARCH = "Type to search";
export const PLEASE_SELECT_ADVERTISER = "Please select advertiser(s)";
export const PUBLISHER_FILTER_PLACEHOLDER = "Enter Publisher CID or Name";

/* Custom Baseline */
export const BASELINE_NOT_AVAILABLE = "Not Available";
export const CURRENCY_AND_PERCENTAGE_FORMAT_LOCALE = "en-US";
export const FETCHING_BASELINE = "Fetching Baseline value...";

/* Excel Download */
export const SINGLE_TAB_DOWNLOAD = "Single Tab Excel";
export const MULTI_TAB_DOWNLOAD = "Multi Tab Excel";
export const DOWNLOAD_SINGLE_TAB = "Download Single Tab";
export const DOWNLOAD_MULTI_TAB = "Download Multi Tab";
export const EXCEL_DOWNLOAD_ERROR = "Sorry, we ran into an issue while downloading the placements. Please try again or contact the Support Team.";

/* Column Chooser */
export const COLUMN_CHOOSER_HEADER = "Choose Columns";
export const SELECT_ALL = "Select All";
export const APPLY = "Apply";
export const PLACEMENT_TYPE_LOCATION_KEY = "placementtype";
export const PLACEMENT_NAME_KEY = "placementname";
export const END_DATE_KEY = "enddate";
export const START_DATE_KEY = "startdate";
export const PUBLISHER_NAME_KEY = "publishername";
export const PUBLISHER_CID_KEY = "publishercompanyid";
export const PUBLISHER_PID_KEY = "publisherpropertyid";
export const ADVERTISER_CID_KEY = "advertisercompanyid";
export const ADVERTISER_NAME_KEY = "advertisername";
export const RESET = "Reset";

export const BOOKED_STATUS_VALIDATION_ERROR_MESSAGES = "Excel columns AG through BG can be provided only if Status is Booked";
export const INVALID_START_DATE_ERROR = 'Invalid Start Date & Time';
export const INVALID_END_DATE_ERROR = 'Invalid End Date & Time';
export const DEFAULT_SELECTED_COLUMN = [
    START_DATE_KEY,
    END_DATE_KEY,
    ADVERTISER_CID_KEY,
    ADVERTISER_NAME_KEY,
    STATUS,
    PUBLISHER_NAME_KEY,
    PUBLISHER_CID_KEY,
    PUBLISHER_PID_KEY,
    PLACEMENT_TYPE_LOCATION_KEY];

export const MANDATORY_UI_COLUMNS = [PLACEMENT_NAME_KEY];

export const SINGLE_SHEET_MANDATORY_EXCEL_COLUMNS = [
    {key: "placementcreated", label: PLACEMENT_CREATION_DATE_TIME_LABEL},
    {key: "placementcreatedby", label: PLACEMENT_CREATED_BY_LABEL},
    {key: "forecastlastupdated", label: PERFORMANCE_LAST_UPDATED_ON_LABEL},
    {key: "validationcreated", label: VALIDATION_DETAILS_CREATED_ON_LABEL},
    {key: "validationcreatedby", label: VALIDATION_DETAILS_CREATED_BY_LABEL},
    {key: "validationlastupdated", label: VALIDATION_DETAILS_LAST_UPDATED_ON_LABEL},
    {key: "validationlastupdatedby", label: VALIDATION_DETAILS_LAST_UPDATED_BY_LABEL},
    {key: "paymentcreated", label: PAYMENT_DETAILS_CREATED_ON_LABEL},
    {key: "paymentcreatedby", label: PAYMENT_DETAILS_CREATED_BY_LABEL},
    {key: "paymentlastupdated", label: PAYMENT_DETAILS_LAST_UPDATED_ON_LABEL},
    {key: "paymentlastupdatedby", label: PAYMENT_DETAILS_LAST_UPDATED_BY_LABEL}
]
export const MULTI_SHEET1_MANDATORY_EXCEL_COLUMNS = [
    {key: "placementcreated", label: PLACEMENT_CREATION_DATE_TIME_LABEL},
    {key: "placementcreatedby", label: PLACEMENT_CREATED_BY_LABEL}
]
export const MULTI_SHEET2_MANDATORY_EXCEL_COLUMNS = [
    {key: "placementcreated", label: PLACEMENT_CREATION_DATE_TIME_LABEL},
    {key: "placementcreatedby", label: PLACEMENT_CREATED_BY_LABEL},
    {key: "forecastlastupdated", label: PERFORMANCE_LAST_UPDATED_ON_LABEL},
]
export const MULTI_SHEET3_MANDATORY_EXCEL_COLUMNS = [
    {key: "validationcreated", label: VALIDATION_DETAILS_CREATED_ON_LABEL},
    {key: "validationcreatedby", label: VALIDATION_DETAILS_CREATED_BY_LABEL},
    {key: "validationlastupdated", label: VALIDATION_DETAILS_LAST_UPDATED_ON_LABEL},
    {key: "validationlastupdatedby", label: VALIDATION_DETAILS_LAST_UPDATED_BY_LABEL},
    {key: "paymentcreated", label: PAYMENT_DETAILS_CREATED_ON_LABEL},
    {key: "paymentcreatedby", label: PAYMENT_DETAILS_CREATED_BY_LABEL},
    {key: "paymentlastupdated", label: PAYMENT_DETAILS_LAST_UPDATED_ON_LABEL},
    {key: "paymentlastupdatedby", label: PAYMENT_DETAILS_LAST_UPDATED_BY_LABEL}
]

/*Width of Modal Tooltips*/
export const WIDTH_DEFAULT = '270px';
export const TOOLTIP_PROPS = {
    placement: "top-start",
    maxWidth: WIDTH_DEFAULT
}

/*Remove Modal*/
export const REMOVE_MODAL_MESSAGE = 'Please confirm the permanent removal of placement:';
export const REMOVE = 'REMOVE';
export const ROUTE_BULK_UPLOAD = 'bulk-upload';
export const BULK_UPLOAD_TITLE = 'Bulk Upload';
export const DATATABLE_LICENSE_KEY = "CompanyName=CJ,LicensedApplication=Campaigns,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=4,LicensedProductionInstancesCount=1,AssetReference=AG-033491,SupportServicesEnd=28_February_2024_[v2]_MTcwOTA3ODQwMDAwMA==268b51a93883a87317b3e239a22911ee";
export const TYPE_BATCH = 'Batch';
export const NOTE_TYPE = "alert";
export const MANUALLY_CALCULATED_BASELINE_WARNING_MESSAGE = "Selecting the manually calculated zero ({currencyValue}) baseline for the placement will impact performance forecasting. Projected Revenue will also be {currencyValue}.";
export const AUTO_CALCULATED_BASELINE_WARNING_MESSAGE = "Selecting the auto calculated zero ({currencyValue}) baseline for the placement will impact performance forecasting. Projected Revenue will also be {currencyValue}.";
export const YOY_REVENUE_WARNING_MESSAGE = "This Publisher Property ID has not generated any revenue for the Advertiser in the last 90 days. Selecting a non-revenue generating PID will impact the performance reporting.";
export const ASCENDING = "ascending";
export const DESCENDING = "descending";
